import React from "react";
import {
    makeStyles, withStyles,
    Grid, Typography, Button, FormControl, NativeSelect, InputBase
} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import Review from '../components/Review';
import customAxios from "../../../../API/customAxios";
import { pxToRem, breakpoints } from '../../../../UIComponent/CommonStyle'
import { checkUndefined } from '../../../../Function/globalFunction'
import CircularProgress from "@material-ui/core/CircularProgress";

const BootstrapInput = withStyles((theme) => ({
    root: {
        marginRight: theme.spacing(1),
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 12,
        [breakpoints.up("md")]: {
            fontSize: 14
        },
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        minWidth: 120,
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex-direction',
        flexWrap: 'wrap',
    },
    formSubtitle: {
        fontSize: pxToRem(14),
        fontWeight: 600,
        color: '#3F51B5',
        [breakpoints.up("md")]: {
            fontSize: pxToRem(16)
        },
        paddingBottom: theme.spacing(1),
    },
    saveButtonDiv: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    saveButton: {
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        },
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    }
}));

export default function ApproverRecord({
    showId,
    updateApproverRecord,
    backToTable
}) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [employee, setEmployee] = React.useState([]);
    const [values, setValues] = React.useState({
        employeeName: '',
        firstApproverId: '',
        secondApproverId: ''
    });

    React.useEffect(() => {
        customAxios.get(`/get_employee?filter[active]=1&select[]=position&select[]=employee_name&select[]=id`)
            .then(res => {
                var getEmployee = res.data;
                setEmployee(getEmployee);
            })
    }, [])

    React.useEffect(() => {
        customAxios.get(`/get_employee_approver/` + showId)
            .then(res => {
                var getEmployeeApprover = res.data;
                setValues({
                    employeeName: `${getEmployeeApprover.employee_name}`,
                    firstApproverId: `${checkUndefined(getEmployeeApprover.approver.first_approver)}`,
                    secondApproverId: `${checkUndefined(getEmployeeApprover.approver.second_approver)}`,
                    firstApproverName: `${checkUndefined(getEmployeeApprover.approver.first_approver_employee, 'employee_name')}`,
                    secondApproverName: `${checkUndefined(getEmployeeApprover.approver.second_approver_employee, 'employee_name')}`,
                })
            })
    }, [showId])

    // Selector change handling
    const handleChange = (event) => {
        const name = event.target.name;

        setValues({
            ...values,
            [name]: event.target.value,
        });
    };

    // Application summary pop up handling
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const updateApprover = (databaseValues) => {
        updateApproverRecord(databaseValues);
    };

    // Form submission handling
    const handleSubmit = evt => {
        evt.preventDefault();
        if (values.firstApproverId === '') {
            switch (values.secondApproverId) {
                case '':
                    handleOpen();
                    break;
                default:
                    alert('If first approver is none, second approver must be none');
                    break
            }
        } else {
            handleOpen();
        }
    };

    // Convert type id to string
    function approverIdtoName(id) {
        if (id === '') {
            return '';
        } else {
            var findApprover = employee.find(item => item.id == id);
            return findApprover.employee_name;
        }
    }

    return (
        <div>
            <form className={classes.root} noValidate autoComplete="off">
                {employee.length > 0 ?
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            First Approver
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <div className={classes.saveButtonDiv}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                onClick={handleSubmit}
                                className={classes.saveButton}
                            >
                                Save
                        </Button>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <NativeSelect
                                id="first_approver_id"
                                value={values.firstApproverId}
                                onChange={handleChange}
                                inputProps={{
                                    name: 'firstApproverId',
                                    id: 'first-approver-native-disabled',

                                }}
                                input={<BootstrapInput />}
                            >
                                <option aria-label="None" value="">None</option>
                                {employee.map(({ id, employee_name, position }, index) => {
                                    return <option key={index} value={id}>{employee_name + ' (' + position + ')'}</option>;
                                })}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                            Second Approver
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <NativeSelect
                                id="second_approver_id"
                                value={values.secondApproverId}
                                onChange={handleChange}
                                inputProps={{
                                    name: 'secondApproverId',
                                    id: 'second-approver-native-disabled',

                                }}
                                input={<BootstrapInput />}
                            >
                                <option aria-label="None" value="">None</option>
                                {employee.map(({ id, employee_name, position }, index) => {
                                    return <option key={index} value={id}>{employee_name + ' (' + position + ')'}</option>;
                                })}
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                </Grid>
                  :
                  <div className={classes.circularProgress}>
                      <CircularProgress />
                  </div>
                }
                {open && (
                    <Review
                        handleClose={handleClose}
                        backToTable={backToTable}
                        open={open}
                        showId={showId}
                        employeeName={values.employeeName}
                        firstApproverId={values.firstApproverId}
                        secondApproverId={values.secondApproverId}
                        firstApproverName={approverIdtoName(values.firstApproverId)}
                        secondApproverName={approverIdtoName(values.secondApproverId)}
                        updateApprover={updateApprover}
                    />
                )}
            </form>
        </div >
    );
}
